import { render } from "./FadeInOutComponent.vue?vue&type=template&id=381ff210"
import script from "./FadeInOutComponent.vue?vue&type=script&lang=js"
export * from "./FadeInOutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__